import { useState } from "react";
import { usd, fmtDate, TXN_LABELS } from "@/lib/api";
import { useFetch, PageHeader, Panel, StatusBadge, Table, Empty, Loading } from "@/components/common";

export default function Transactions() {
  const [type, setType] = useState("");
  const { data, loading } = useFetch(`/transactions${type ? `?type=${type}` : ""}`);
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Ledger" title="Transaction history" subtitle="Every credit and debit on your account."
        actions={
          <select className="nx-input w-52" value={type} onChange={(e) => setType(e.target.value)} data-testid="txn-type-filter">
            <option value="">All types</option>
            {Object.entries(TXN_LABELS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        } />
      <Panel>
        {loading ? <Loading /> : (
          <Table head={["Date", "Type", "Description", "Amount", "Currency", "Status"]} testid="transactions-table">
            {!data?.length && <Empty cols={6} text="No transactions found" />}
            {data?.map((t) => (
              <tr key={t.id} data-testid={`txn-row-${t.type}`}>
                <td className="nx-td">{fmtDate(t.created_at)}</td>
                <td className="nx-td">{TXN_LABELS[t.type] || t.type}</td>
                <td className="nx-td text-white">{t.description}</td>
                <td className={`nx-td num ${t.direction === "debit" ? "" : "text-[#10B981]"}`}>
                  {t.direction === "debit" ? "−" : t.direction === "credit" ? "+" : ""}{usd(t.amount)}
                </td>
                <td className="nx-td">{t.currency}</td>
                <td className="nx-td"><StatusBadge status={t.status} /></td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>
    </div>
  );
}
